import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { TranslateService } from '../../../core/services/translate.service';

@Component({
  selector: 'tt-stock-batch-get',
  templateUrl: './stock-batch-get.component.html',
  styleUrls: ['./stock-batch-get.component.css']
})
export class StockBatchGetComponent implements OnInit {
    stockBatchKeyno;

    public webPageName: string = this.stateService.getCurrentName();

    public selectedBgBatchDelivery: string = '0';

    public stockLocationNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-search', goto: 'selectstocklocation', gotoParms: () => this.edit!.stockplace_id ?? '' }];

    public productButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.edit!.prod_keyno ?? '' }];

    public allocationInfoButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', onClick: () => this.goToFunc('allocation_state') }];

    public purchaseOrderButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'purchhead', gotoParms: () => this.edit!.purch_internal_no ?? '' }];

    public batchDeliveryButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'batchdelivery', gotoParms: () => this.edit!.batchdelivery_keyno ?? '' }];

    public edit?: Edit;

    public p2ReportDefKeyno: string = '';

    public saving = false;

    private translations: { [key: string]: string } = {
        confirm_no_allocation: '',
        printdialogue_undefined_report: ''
    };

    constructor(private stateService: StateService, private translateService: TranslateService, private modal: ModalService, private datatask: DataTaskService) {
        this.stockBatchKeyno = this.stateService.getStateParams()['stockbatch_keyno'];
    }

    private async translate() {
        const response = await this.translateService.translateBatch(Object.keys(this.translations));

        Object.keys(this.translations).forEach((key) => {
            if (response[key]) {
                this.translations[key] = response[key];
            }
        });
    }

    private async loadEdit() {
        if (!!this.stockBatchKeyno) {
            this.edit = (await this.datatask.Post(293, { stockbatch_keyno: this.stockBatchKeyno }))[0];
        }
    }

    private async retrieveReportDefinitions() {
        if (!this.edit) return;

        const response = (await this.datatask.Post(1624, { report_filename: this.edit.report_name }))[0];
        
        this.p2ReportDefKeyno = response?.p2_reportdef_keyno;
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(474, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async goToFunc(state: any) {
        if (!this.edit) return;

        switch (state) {
            case 'allocation_state':
                if (this.edit.allocation_state === '' || this.edit.allocation_parms === '') {
                    await this.modal.openConfirmDialog({
                        title: 'confirm_title',
                        translateMessage: true,
                        message: this.translations['confirm_no_allocation'],
                        type: 'danger'
                    });
                } else {
                    this.stateService.go(this.edit.allocation_state, this.edit.allocation_parms);
                }
                break;
            case 'printdialogue':
                if (!!this.p2ReportDefKeyno) {
                    this.stateService.go('printdialogue', {
                        webpage_name: this.webPageName,
                        argtype: 'stockbatch_keyno',
                        argvalue: this.edit.stockbatch_keyno,
                        p2_reportdef_keyno: this.p2ReportDefKeyno
                    });
                } else {
                    await this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: this.translations['printdialogue_undefined_report']
                    });
                }
                break;
            case 'selectreport':
                this.stateService.go('selectreport', {
                    webpage_name: this.webPageName,
                    argtype: 'stockbatch_keyno',
                    argvalue: this.edit.stockbatch_keyno
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.translate();
        await this.loadEdit();

        if (!!this.edit!.stockplace_id) this.retrieveReportDefinitions();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stockbatch_keyno: string;
    reg_datetime: string;
    po_keyno: string;
    stock_keyno: string;
    description: string;
    suppliers_batchno: string;
    batchdelpurchlinesb_keyno: string;
    price_locval: string;
    purchprice_locval: string;
    purchprice_invval: string;
    freight_eu: string;
    freight_ex_eu: string;
    customs_eu: string;
    customs_ex_eu: string;
    divcost: string;
    country_id_origin: string;
    origin_type: string;
    origin_name: string;
    quantity: string;
    quantity_stock: string;
    quantity_reserved: string;
    stocklocation_keyno: string;
    p2_pofinishprod_keyno: string;
    opcost_var_var: string;
    show_button_pofinishprodworks: string;
    allocation_info: string;
    stockplace_id: string;
    stockplace_name: string;
    stocklocation_name: string;
    allocation_path: string;
    allocation_state: string;
    allocation_parms: string;
    purch_order_no: string;
    purch_internal_no: string;
    batchdelivery_keyno: string;
    prod_id: string;
    prod_keyno: string;
    prod_name_long: string;
    valuta_id: string;
    stock_datetime: string;
    exchangerate: string;
    nbr_of_forms: string;
    best_before_date: string;
    change_best_before_date: string;
    new_best_before_date: string;
    report_name: string;
    nbr_of_stockcorrections: string;
    setting_select_report: string;
    nbr_of_documents: string;
    nbr_of_pictures: string;
}
